import { createFileRoute, redirect } from "@tanstack/react-router";
import { legacyArticleSlugs } from "@/utils/slugUtils";

export const Route = createFileRoute("/articles/$slug")({
  beforeLoad: ({ params }) => {
    const target = legacyArticleSlugs[params.slug] ?? params.slug;
    throw redirect({ to: "/artigos/$slug", params: { slug: target }, statusCode: 301 });
  },
});